import { Button } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
/**
 * SubmitButton renders a styled primary button intended for form submission.
 * It applies a default outline-and-color style, and displays a loading spinner when needed.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children       The content or label of the button.
 * @param {boolean}       [props.loading=false] Whether to show the loading spinner.
 * @param {Object}        [rest]                Any other Ant Design Button props to pass through.
 * @returns {JSX.Element} The rendered submit button.
 */
const SubmitButton = ({ children, loading, ...rest }) => {
	const defaultStyle = {
		boxShadow: 'unset'
	}
	return (
		<Button
			type="primary"
			htmlType="submit"
			loading={loading}
			{...rest}
			style={
				rest.style ? { ...defaultStyle, ...rest.style } : defaultStyle
			}
		>
			{children}
		</Button>
	)
}

SubmitButton.propTypes = {
	children: PropTypes.node.isRequired,
	loading: PropTypes.bool
}
export default SubmitButton
